import { findChallengeBySlugs } from '@devlearn/content';
import { useQuery } from '@tanstack/react-query';
import { loadChapter, loadRecap } from './loadChapter';

/** `['content', track, chapter]` — content is bundled code, so it never goes stale. */
export function useChapterContent(trackSlug: string, chapterSlug: string, enabled = true) {
  return useQuery({
    queryKey: ['content', trackSlug, chapterSlug],
    queryFn: () => loadChapter(trackSlug, chapterSlug),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled,
  });
}

/** The challenge at a URL: its structure (synchronous) and its full content (lazy chunk). */
export function useChallengeContent(trackSlug: string, chapterSlug: string, challengeSlug: string) {
  const location = findChallengeBySlugs(trackSlug, chapterSlug, challengeSlug);
  const chapter = useChapterContent(trackSlug, chapterSlug, Boolean(location));
  const challenge = chapter.data?.challenges.find((c) => c.slug === challengeSlug);
  return { location, chapter, challenge };
}

export function useRecapQuestions(trackSlug: string, chapterSlug: string | undefined) {
  return useQuery({
    queryKey: ['content', 'recap', trackSlug, chapterSlug],
    queryFn: () => loadRecap(trackSlug, chapterSlug!),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: Boolean(chapterSlug),
  });
}
